var Eventable = require('../../lib/Eventable');

var eventable = new Eventable();

var utils = require('./utils');

var isEmpty = utils.isEmpty;

var mapList = {};

module.exports = {
    createKey: function (callback_id) {
        if (!isEmpty(callback_id)) {
            return 'perm-' + callback_id;
        }
        else {
            return 'temp-' + callback_id;
        }
    },
    register: function (name, callback) {
        if (isEmpty(name)) {
            return;
        }
        if (!isEmpty(mapList[name])) {
            console.warn('warning, callback ' + name + ' has been registered, removing old callback');
            eventable.removeEventListener(name, callback);
            delete mapList[name];
        }
        eventable.addEventListener(name, callback);
        mapList[name] = true;
    },
    unregister: function (name, callback) {
        eventable.removeEventListener(name, callback);
        delete mapList[name];
    },
    dispatch: function (name, action) {
        eventable.triggerEvent(name, action);
    }
};
